import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetonagpurcabhire() {



  const cardData =
  {
    keyword: 'Pune to Nagpur Cab Hire',
    heading: 'Sai Trupti Cabs: Pune to Nagpur Cab Hire',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune to Nagpur cab hire services, designed to make your long-distance journey smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors and ample luggage space for your travel comfort. Every journey is driven by a professional, background-verified chauffeur who ensures punctual pickup in Pune, courteous service, and safe, smooth driving all the way to Nagpur. With transparent one-way fares, flexible booking options (one-way or round-trip), and 24×7 customer support, Sai Trupti Cabs makes your travel from Pune to Nagpur convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Nagpur with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Deekshabhoomi",
    "description": "Deekshabhoomi is Nagpur’s most iconic spiritual landmark — a grand Buddhist stupa where Dr. Babasaheb Ambedkar and thousands of his followers embraced Buddhism in 1956. The massive white dome stands as a symbol of peace, equality, and enlightenment. Surrounded by lush gardens, the stupa radiates calm and serenity, especially during evening prayers. Devotees and visitors alike come to meditate and reflect on the teachings of compassion and justice. During Dhamma Chakra Pravartan Day in October, Deekshabhoomi transforms into a sea of devotion and unity. It is the beating spiritual heart of Nagpur."
  },
  {
    "title": "Futala Lake",
    "description": "Futala Lake, located in the western part of Nagpur, is one of the city’s most popular hangout spots, loved for its scenic beauty and lively evenings. Built over 200 years ago, the lake is surrounded by lush greenery and features a mesmerizing musical fountain that comes alive after sunset. The promenade is lined with street-food stalls serving chaats, dosas, and ice cream. Couples, families, and joggers frequent the area to enjoy the cool breeze and glowing reflections on the water. Futala Lake beautifully captures Nagpur’s balance between urban energy and natural calm."
  },
  {
    "title": "Sitabuldi Fort",
    "description": "Sitabuldi Fort, perched on twin hills in the center of Nagpur, is a historic monument built in 1817 during the Battle of Sitabuldi. The fort offers panoramic views of the city skyline and holds deep historical significance as a witness to Maratha and British conflicts. Inside, visitors can explore old barracks, memorials, and the resting place of brave soldiers. Although part of it remains under military control, guided tours are available on select days. The fort’s elevated vantage point and timeless architecture make it a must-visit for history enthusiasts."
  },
  {
    "title": "Ambazari Lake and Garden",
    "description": "Ambazari Lake, the largest lake in Nagpur, is surrounded by a beautifully landscaped garden and walking trails. The lake was originally built to supply water to the city and now serves as a peaceful recreational hub. Boating facilities, fountains, and children’s play zones make it ideal for families. The adjoining Ambazari Garden offers a refreshing escape with its greenery and vibrant flowerbeds. During monsoon, the lake’s reflections and gentle mist create a serene atmosphere. Ambazari Lake is where nature and leisure coexist harmoniously in the heart of Nagpur."
  },
  {
    "title": "Raman Science Centre & Planetarium",
    "description": "The Raman Science Centre and Planetarium is a fascinating destination that inspires curiosity and learning among children and adults alike. Named after Nobel laureate Sir C.V. Raman, the center features interactive science exhibits, a 3D theater, and astronomy shows that explore the wonders of space. The planetarium’s dome projection offers an immersive experience of stars, planets, and galaxies. Science fairs and workshops are regularly held, making it a hub for innovation and discovery. It’s a perfect educational outing for families and students visiting Nagpur."
  },
  {
    "title": "Maharajbagh Zoo",
    "description": "Maharajbagh Zoo, located in the center of Nagpur, is one of the city’s oldest zoological parks, developed from the gardens of the Bhonsle kings. Spread across lush green acres, it houses tigers, leopards, deer, and a variety of birds. The shaded walkways, fountains, and play areas make it a relaxing retreat for families. The adjoining botanical garden showcases beautiful flora and medicinal plants. Maharajbagh Zoo offers a blend of recreation, education, and conservation — bringing people closer to wildlife in the heart of the city."
  },
  {
    "title": "Dragon Palace Temple, Kamptee",
    "description": "The Dragon Palace Temple, located in Kamptee near Nagpur, is a stunning Buddhist temple known for its magnificent white structure and tranquil surroundings. Built with Japanese collaboration, it symbolizes Indo-Japanese friendship and peace. The main prayer hall houses a large statue of Buddha radiating calmness and compassion. The landscaped gardens and lotus ponds add to the serenity of the site. Visitors experience a deep sense of peace as they walk through the corridors echoing soft chants. The temple is often referred to as the ‘Lotus Temple of Nagpur’ for its architectural elegance and divine aura."
  },
  {
    "title": "Zero Mile Stone",
    "description": "Zero Mile Stone marks the geographical center of India and is one of Nagpur’s most significant historical monuments. Built during the British era, it consists of a sandstone pillar surrounded by four horse statues, symbolizing measurement of distances from Nagpur to other parts of India. The site stands as a reminder of Nagpur’s central role in the country’s geography and trade routes. Today, it’s a well-maintained landmark surrounded by gardens and urban art. Visiting Zero Mile connects travelers to both history and the symbolic heart of India."
  },
  {
    "title": "Balaji Temple, Seminary Hills",
    "description": "The Balaji Temple on Seminary Hills offers a peaceful spiritual retreat surrounded by dense forests and scenic views. Dedicated to Lord Venkateswara (Balaji), the temple’s South Indian-style architecture, gopuram towers, and serene environment attract devotees year-round. The hilltop location provides panoramic views of Nagpur city and the greenery below. The temple is beautifully illuminated at night, adding divine charm to its surroundings. Morning and evening aartis here are deeply soothing, making it one of the most loved places of worship in Nagpur."
  },
  {
    "title": "Pench Tiger Reserve (Nagpur Gateway)",
    "description": "Located about 90 km from Nagpur, Pench Tiger Reserve is one of India’s premier wildlife destinations and the inspiration behind Rudyard Kipling’s ‘The Jungle Book.’ Spread across Maharashtra and Madhya Pradesh, it is home to tigers, leopards, deer, wild boars, and over 200 bird species. Safari tours offer thrilling experiences through dense forests, grasslands, and serene riverbanks. The reserve also focuses on eco-tourism and wildlife conservation. For adventure seekers and nature lovers, Pench offers a chance to witness the raw majesty of India’s wilderness just a short drive from Nagpur."
  }
],



"services": [
  {
    "name": "Pune to Nagpur Cab Hire",
    "description": "Hire a reliable cab from Pune to Nagpur with professional drivers, luggage assistance, AC/non-AC vehicle options, and flexible pickup and drop points. Perfect for long-distance travel, corporate trips, family vacations, and group outings, ensuring a safe, comfortable, and timely journey with transparent fares."
  },
  {
    "name": "Pune to Nagpur Taxi Service",
    "description": "Premium taxi service from Pune to Nagpur with well-maintained vehicles, experienced drivers, luggage support, and AC/non-AC options. Ideal for sightseeing trips, leisure travel, and business travel, offering hassle-free online booking, transparent fares, and a comfortable long-distance ride."
  },
  {
    "name": "Pune to Nagpur Car Hire",
    "description": "Hire cars from Pune to Nagpur for outstation travel including sedans, SUVs, Innova, and Ertiga. Comes with professional drivers, luggage support, flexible schedules, AC/non-AC options, and secure online booking for a smooth and convenient travel experience for families, friends, and corporate clients."
  },
  {
    "name": "Pune to Nagpur AC Cab",
    "description": "Comfortable AC cab service from Pune to Nagpur with professional drivers, luggage assistance, and flexible pickup and drop locations. Suitable for family trips, corporate travel, and long-distance journeys, ensuring a cool and relaxing ride throughout the journey."
  },
  {
    "name": "Pune to Nagpur Non AC Cab",
    "description": "Affordable non-AC cab service from Pune to Nagpur with reliable vehicles, professional drivers, luggage support, and flexible schedules. Perfect for budget-conscious travelers seeking safe, convenient, and comfortable outstation travel."
  },
  {
    "name": "Luxury Cab Pune to Nagpur",
    "description": "Premium luxury cab service from Pune to Nagpur featuring top-class vehicles, AC service, professional chauffeurs, luggage assistance, and punctual pickups. Ideal for weddings, VIP travel, and corporate trips, ensuring a luxurious, comfortable, and hassle-free journey."
  },
  {
    "name": "Pune to Nagpur Innova Cab",
    "description": "Spacious Innova cab from Pune to Nagpur with seating for 6-7 passengers, AC/non-AC options, professional drivers, luggage support, flexible pickup/drop points, and transparent fares. Perfect for family trips, group travel, and corporate outings requiring comfort and reliability."
  },
  {
    "name": "Pune to Nagpur Ertiga Cab",
    "description": "Comfortable Ertiga cab service from Pune to Nagpur with AC/non-AC options, professional drivers, luggage assistance, and flexible pickup/drop locations. Ideal for small families, group outings, and leisure trips, offering a safe and reliable long-distance travel experience."
  },
  {
    "name": "Affordable Pune to Nagpur Cab",
    "description": "Budget-friendly cab service from Pune to Nagpur offering AC/non-AC vehicles, professional drivers, luggage support, flexible schedules, and transparent fares. Perfect for travelers seeking cost-effective yet comfortable and dependable outstation transportation."
  },
  {
    "name": "Pune to Nagpur Outstation Cab",
    "description": "Outstation cab service from Pune to Nagpur with AC/non-AC vehicles, professional drivers, luggage assistance, flexible schedules, and secure online booking. Ideal for weekend trips, leisure travel, and long-distance journeys, providing a comfortable and safe travel experience."
  },
  {
    "name": "Pune to Nagpur One Way Cab",
    "description": "Convenient one-way cab service from Pune to Nagpur with AC/non-AC options, professional drivers, luggage support, and transparent fares. Perfect for travelers who need a one-way drop without worrying about return transportation."
  },
  {
    "name": "Pune to Nagpur Drop Cab",
    "description": "Drop cab service from Pune to Nagpur with AC/non-AC vehicles, professional drivers, luggage assistance, and flexible scheduling. Ensures safe, comfortable, and punctual travel to your destination with transparent pricing and hassle-free booking."
  },
  {
    "name": "Pune to Nagpur Corporate Cab",
    "description": "Corporate cab service from Pune to Nagpur with AC/non-AC vehicles, professional chauffeurs, luggage support, flexible pickup/drop schedules, and online booking. Ideal for business trips, corporate events, and client travel, ensuring comfort, punctuality, and reliability."
  },
  {
    "name": "Pune to Nagpur Wedding Cab",
    "description": "Premium wedding cab service from Pune to Nagpur featuring luxurious vehicles, AC/non-AC options, professional drivers, luggage assistance, and timely pickups. Perfect for weddings, transporting family, guests, and VIPs safely and in style."
  },
  {
    "name": "Pune to Nagpur Online Booking",
    "description": "Book your Pune to Nagpur cab online instantly with secure payments, multiple AC/non-AC vehicle options, professional drivers, luggage support, and flexible pickup/drop points. Convenient for planning trips in advance or on short notice with complete transparency."
  }
],
"tableData": [
  ["Pune to Nagpur Cab Hire", "Pune to Nagpur Taxi Service"],
  ["Pune to Nagpur Car Hire", "Pune to Nagpur AC Cab"],
  ["Pune to Nagpur Non AC Cab", "Luxury Cab Pune to Nagpur"],
  ["Pune to Nagpur Innova Cab", "Pune to Nagpur Ertiga Cab"],
  ["Affordable Pune to Nagpur Cab", "Pune to Nagpur Outstation Cab"],
  ["Pune to Nagpur One Way Cab", "Pune to Nagpur Drop Cab"],
  ["Pune to Nagpur Corporate Cab", "Pune to Nagpur Wedding Cab"],
  ["Pune to Nagpur Online Booking", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Nagpur Cab Hire",
    "WhyChoosedescription": "Sai Trupti Cabs  provides reliable and comfortable cab services from Pune to Nagpur — ideal for business trips, long-distance travel, and leisure journeys."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Get clear one-way fare estimates for Pune to Nagpur cabs, starting at affordable rates depending on the vehicle type — no hidden charges or last-minute surprises."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, or premium cars to suit your group size, luggage, and comfort preferences for your Nagpur trip."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and skilled drivers are familiar with the Pune to Nagpur route, ensuring a safe, smooth, and timely journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We provide pickups from anywhere in Pune (city, airport, or suburbs) and drop-offs at any location in Nagpur, including hotels, railway stations, or residences."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All vehicles are regularly serviced, sanitized, and maintained to ensure comfort and reliability for the long-distance drive from Pune to Nagpur."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated team is available round-the-clock to assist with bookings, route planning, or any travel queries."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Nagpur cab easily via call, WhatsApp, or our website — with instant confirmation and prompt vehicle dispatch."
  }
]

















  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Pune to Nagpur cab hire services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable Pune to Nagpur cab hire services for one-way, round trips, business, and family travel.',
  },
  {
    question: 'How can I hire a cab from Pune to Nagpur with Sai Trupti Cabs?',
    answer: 'You can easily book or hire a cab from Pune to Nagpur through our website, mobile app, or by contacting our 24×7 customer support team for instant confirmation.',
  },
  {
    question: 'What types of cabs are available for Pune to Nagpur travel?',
    answer: 'We offer hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers to match your travel needs, group size, and budget for long-distance trips.',
  },
  {
    question: 'Are the drivers experienced for Pune to Nagpur long-distance trips?',
    answer: 'Yes, all our drivers are professional, courteous, and highly experienced in long-distance routes, ensuring a safe and comfortable journey to Nagpur.',
  },
  {
    question: 'Can I hire a cab from Pune to Nagpur for corporate or family travel?',
    answer: 'Certainly. Our Pune to Nagpur cab hire service caters to corporate, business, and personal travel, including family trips and group tours.',
  },
  {
    question: 'Is the Pune to Nagpur cab hire service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab hire services from Pune to Nagpur for your convenience and flexible travel scheduling.',
  },
  {
    question: 'What are the Pune to Nagpur cab fares?',
    answer: 'Our Pune to Nagpur cab fares start from approximately ₹8,500 for sedans and ₹10,500–₹12,000 for SUVs and larger vehicles, depending on the type and duration of travel.',
  },
  {
    question: 'What payment methods are accepted for Pune to Nagpur cab hire?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, and bank transfers for a smooth and secure booking experience.',
  },
  {
    question: 'What safety and hygiene measures are followed for Pune to Nagpur cabs?',
    answer: 'All our cabs are sanitized before every trip, and our drivers follow strict hygiene and safety standards to ensure a comfortable and secure journey.',
  },
  {
    question: 'Is customer support available during the Pune to Nagpur cab trip?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Pune to Nagpur cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Abhijeet Deshmukh',
    feedback: 'I hired a cab from Pune to Nagpur with Sai Trupti Cabs. The journey was smooth, the car was clean, and the driver was very professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Meenal Patil',
    feedback: 'Excellent Pune to Nagpur cab hire service from Sai Trupti Cabs. On-time pickup, comfortable car, and polite driver. Highly recommended!',
    rating: 5,
  },
];























































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Nagpur Cab Service",
  "image": "https://saitrupticabs.com/assets/images/pune-to-nagpur-cab.jpg",
  "description": "Sai Trupti Cabs offers Pune to Nagpur cab service with one way taxi, round trip cabs, Innova Crysta, Ertiga, sedan and SUV options. Book affordable long distance outstation cabs with professional drivers, 24x7 service and safe travel experience.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7580"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4999",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-nagpur-cab-hire",
    "itemCondition": "https://schema.org/NewCondition"
  }
};






  return (
    <div>
  
<Helmet>
  <title>Pune to Nagpur Cab Service | One Way Taxi ₹4999 | Sai Trupti Cabs</title>

  <meta 
    name="description" 
    content="Book Pune to Nagpur cab at best price ₹4999 with Sai Trupti Cabs. One way taxi, round trip, Innova Crysta, Ertiga, sedan & SUV available. Safe, reliable and 24x7 cab service for long distance travel." 
  />

  <meta 
    name="keywords" 
    content="pune to nagpur cab, pune to nagpur taxi, pune to nagpur cab service, pune to nagpur one way cab, pune to nagpur taxi fare, pune to nagpur innova crysta, pune to nagpur ertiga cab, pune to nagpur sedan cab, cheap pune to nagpur cab, best cab service pune to nagpur, pune to nagpur drop taxi, pune to nagpur round trip cab, outstation cab pune to nagpur, pune to nagpur online cab booking" 
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/43.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetonagpurcabhire;